import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from 'react';
import Spinner from '../../shared/spinner';
import InputMask from 'react-input-mask';
import { format, parse, subDays } from 'date-fns';
import { Empregador } from '../../shared/model/empregador';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { RelatoriosDTO } from '../../shared/dto/relatoriosDTO';
import ArquivoService from '../../services/arquivoService';
import EmpregadorService from '../../services/empregadorService';
import CustomAlert from '../../shared/customAlert';
import { useVerificaPermissao } from '../../shared/useVerificaPermissao';
import RelatorioService from '../../services/relatorioService';
import RelatoriosAgendadosService from '../../services/relatoriosAgendadosService';
import { AgendarRelatorioDTO } from '../../shared/dto/agendarRelatorioDTO';
import OriginadorService from '../../services/originadorService';
import PromotoraService from '../../services/promotoraService'; // <--- ADICIONADO
import { Originador } from '../../shared/model/originador';

function ExtratoMensalComponent() {
  useVerificaPermissao();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const [loading, setLoading] = useState(false);
  const [showAgendamentoModal, setShowAgendamentoModal] = useState(false);
  const [errorRelatorio, setErrorRelatorio] = useState<string | null>(null);
  const [totalLinhasRelatorio, setTotalLinhasRelatorio] = useState<number | null>(null);

  const [dtBase1, setDtBase1] = useState(format(subDays(new Date(), 15), 'dd/MM/yyyy'));
  const [dtBase2, setDtBase2] = useState(format(new Date(), 'dd/MM/yyyy'));
  const [agendamentoData, setAgendamentoData] = useState(() => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  });

  const [selectedOrigem, setSelectedOrigem] = useState('');

  const [tiposOrigemOptions, setTiposOrigemOptions] = useState<string[]>([]);

  // --- ESTADOS DO ORIGINADOR (DUAL LIST BOX) ---
  const [availableOriginadores, setAvailableOriginadores] = useState<Originador[]>([]);
  const [selectedOriginadores, setSelectedOriginadores] = useState<Originador[]>([]);
  const [selectedToMoveOriginadores, setSelectedToMoveOriginadores] = useState<Originador[]>([]);
  const [selectedFromSelectedOriginadores, setSelectedFromSelectedOriginadores] = useState<Originador[]>([]);

  const [availableOrigens, setAvailableOrigens] = useState<any[]>([]);
  const [selectedOrigens, setSelectedOrigens] = useState<any[]>([]);
  const [selectedToMoveOrigens, setSelectedToMoveOrigens] = useState<any[]>([]);
  const [selectedFromSelectedOrigens, setSelectedFromSelectedOrigens] = useState<any[]>([]);

  const [availableEmpregadores, setAvailableEmpregadores] = useState<Empregador[]>([]);
  const [selectedEmpregadores, setSelectedEmpregadores] = useState<Empregador[]>([]);
  const [selectedToMoveEmpregadores, setSelectedToMoveEmpregadores] = useState<Empregador[]>([]);
  const [selectedFromSelectedEmpregadores, setSelectedFromSelectedEmpregadores] = useState<Empregador[]>([]);

  // Instância dos serviços
  const arquivoService: ArquivoService = new ArquivoService();
  const relatorioService: RelatorioService = new RelatorioService();
  const empregadorService: EmpregadorService = new EmpregadorService();
  const relatoriosAgendadosService = new RelatoriosAgendadosService();
  const originadorService: OriginadorService = new OriginadorService();
  const promotoraService: PromotoraService = new PromotoraService(); // <--- ADICIONADO

  const carregarTiposOrigem = async () => {
    setLoading(true);
    try {
      const response = await arquivoService.listarTiposOrigem();
      const listaTipos = response.data;
      setTiposOrigemOptions(listaTipos);

      if (listaTipos && listaTipos.length > 0) {
        let tipoInicial = listaTipos[0];
        if (listaTipos.includes('MATRIZ')) {
            tipoInicial = 'MATRIZ';
        }
        setSelectedOrigem(tipoInicial);
        listarOrigens(tipoInicial);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error("Erro ao listar tipos de origem", err);
      const fallbackOptions = ['MATRIZ', 'PROMOTORA', 'SUPERVISOR', 'OPERADOR', 'PONTO_VENDA'];
      setTiposOrigemOptions(fallbackOptions);
      setSelectedOrigem('MATRIZ');
      listarOrigens('MATRIZ');
    }
  };

  const listarOrigens = async (origem: string) => {
    setLoading(true);
    try {
      const response = await arquivoService.listarOrigemGenerica(origem);

      setAvailableOrigens(response.data);
      setSelectedOrigens([]);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  const listarEmpregadores = async () => {
    setLoading(true);
    try {
      const response = await empregadorService.listarTodosEmpregadoresAtivos();
      setAvailableEmpregadores(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  const listarOriginadores = async () => {
    setLoading(true);
    try {
        const response = await originadorService.listarTodasOriginadoresPorRole(); 
        setAvailableOriginadores(response.data);
        // setSelectedOriginadores([]); // Comentado para evitar limpar ao recarregar a página sem necessidade
        setLoading(false);
    } catch (err) {
        setLoading(false);
        console.error(err);
    }
  };

  // --- NOVA LÓGICA: FILTRAR PROMOTORAS AO SELECIONAR ORIGINADOR ---
  useEffect(() => {
    const atualizarPromotorasPorOriginador = async () => {
      // Só executa se o tipo selecionado for PROMOTORA
      if (selectedOrigem === 'PROMOTORA') {
        
        // Se tiver originadores selecionados, busca filtrado
        if (selectedOriginadores.length > 0) {
          setLoading(true);
          try {
            const idsOriginadores = selectedOriginadores.map(o => o.id);
            const response = await promotoraService.buscarPorOriginador(idsOriginadores);
            
            // Filtra para não mostrar nas disponíveis as que JÁ estão nas selecionadas
            const novasDisponiveis = response.data.filter((p: any) => 
              !selectedOrigens.some((sel: any) => sel.id === p.id)
            );

            setAvailableOrigens(novasDisponiveis);
          } catch (err) {
            console.error("Erro ao filtrar promotoras por originador", err);
            setAlert({ message: 'Erro ao filtrar promotoras', type: 'error' });
          } finally {
            setLoading(false);
          }
        } else {
          // Se limpar os originadores, volta a listar todas as promotoras
          listarOrigens('PROMOTORA');
        }
      }
    };

    atualizarPromotorasPorOriginador();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOriginadores, selectedOrigem]); 
  // ----------------------------------------------------------------

  const gerarRelatorio = async () => {
    if (selectedOrigens.length <= 0) return setAlert({ message: 'Selecione ao menos uma Origem', type: 'warning' });
    if (selectedEmpregadores.length <= 0) return setAlert({ message: 'Selecione ao menos um Empregador', type: 'warning' });
    if (dtBase1 === '' || dtBase2 === '') return setAlert({ message: 'Preencha os campos de datas!', type: 'warning' });
    
    // Validação do Originador
    if (selectedOrigem === 'PROMOTORA' && selectedOriginadores.length <= 0) {
        return setAlert({ message: 'Selecione ao menos um Originador', type: 'warning' });
    }

    if (dtBase1 !== '' && dtBase2 !== '' && parse(dtBase1, "dd/MM/yyyy", new Date()) > parse(dtBase2, "dd/MM/yyyy", new Date())) return setAlert({ message: 'Data inicial deve ser inferior a data final', type: 'warning' });

    setLoading(true);
    try {
      const dto: RelatoriosDTO = new RelatoriosDTO();
      dto.empregadores = selectedEmpregadores;
      dto.tipoOrigemIds = selectedOrigens.map(origem => origem.id);
      dto.dtBase1 = parse(dtBase1, "dd/MM/yyyy", new Date());
      dto.dtBase2 = parse(dtBase2, "dd/MM/yyyy", new Date());
      dto.tipoOrigem = selectedOrigem;

      // Envio dos IDs dos Originadores
      if (selectedOrigem === 'PROMOTORA') {
          (dto as any).originadorIds = selectedOriginadores.map(o => o.id);
      }

      const response = await relatorioService.gerarRelatorioExtratoMensal(dto);

      const contentType = response.headers['content-type'];

      if (contentType === 'text/plain') {
        const errorText = await response.data.text();
        setAlert({ message: errorText, type: 'warning' });
      } else {
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', 'Relatorio_Extrato_Mensal.xlsx');

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }

      setLoading(false);
    } catch (err: any) {
      setLoading(false);

      if (err.response && err.response.status === 500 && err.response.data instanceof Blob) {
        try {
          const errorText = await err.response.data.text();
          const parsed = JSON.parse(errorText);

          if (
            parsed &&
            typeof parsed === 'object' &&
            'message' in parsed &&
            'maxAllowed' in parsed &&
            'totalRows' in parsed &&
            parsed.status === 'error'
          ) {
            setErrorRelatorio(parsed.message);
            setTotalLinhasRelatorio(parsed.totalRows);
          } else {
            setErrorRelatorio(errorText);
            setTotalLinhasRelatorio(null);
          }
        } catch (parseError) {
          setErrorRelatorio('Erro desconhecido ao gerar relatório.');
          setTotalLinhasRelatorio(null);
          console.error('Erro ao fazer parse do JSON de erro:', parseError);
        }

        setShowAgendamentoModal(true);
      } else if (err.response && err.response !== 'AXIOS_TIMEOUT') {
        setAlert({ message: 'Ocorreu um erro ao gerar o relatório', type: 'error' });
      }
      console.error(err);
    }
  };

  const agendarRelatorio = async () => {
    const userId = localStorage.getItem("id") ?? ""; 

    if (!agendamentoData) {
      setAlert({ message: "Por favor, selecione a data do agendamento.", type: "warning" });
      return;
    }

    const selectedDate = new Date(agendamentoData);
    const now = new Date();

    selectedDate.setHours(0, 0, 0, 0);
    now.setHours(0, 0, 0, 0);

    if (selectedDate < now) {
      setAlert({ message: "A data de agendamento não pode ser anterior a hoje.", type: "warning" });
      return;
    }

    const parametros = {
      dtBase1: format(parse(dtBase1, "dd/MM/yyyy", new Date()), "yyyy-MM-dd"),
      dtBase2: format(parse(dtBase2, "dd/MM/yyyy", new Date()), "yyyy-MM-dd"),
      tipoOrigem: selectedOrigem,
      tipoOrigemIds: selectedOrigens.map(o => o.id),
      empregadores: selectedEmpregadores.map(e => e.id),
      originadorIds: selectedOrigem === 'PROMOTORA' ? selectedOriginadores.map(o => o.id) : null
    };

    const dto: AgendarRelatorioDTO = {
      userId,
      tipoRelatorio: "EXTRATO-MENSAL",
      parametros: JSON.stringify(parametros),
      qtdeLinhas: totalLinhasRelatorio ?? 0,
      programado: selectedDate.toISOString()
    };

    try {
      const response = await relatoriosAgendadosService.solicitarRelatorio(dto);

      if (response.status === 200) {
        setAlert({ message: "Relatório agendado com sucesso!", type: "success" });
      } else {
        setAlert({ message: "Erro ao agendar relatório.", type: "error" });
      }
    } catch (err: any) {
      const msg = err.response?.data || "Erro inesperado ao agendar relatório.";
      setAlert({ message: msg, type: "error" });
      console.error(err);
    } finally {
      setShowAgendamentoModal(false);
      setErrorRelatorio(null);
    }
  };

  useEffect(() => {
    carregarTiposOrigem();
    listarEmpregadores();
    listarOriginadores();
  }, []);

  const moveToSelectedOrigens = () => {
    const newSelected = [...selectedOrigens, ...selectedToMoveOrigens];
    const newAvailable = availableOrigens.filter(
      (origem) => !selectedToMoveOrigens.includes(origem)
    );

    setAvailableOrigens(newAvailable);
    setSelectedOrigens(newSelected);
    setSelectedToMoveOrigens([]);
  };

  const moveToAvailableOrigens = () => {
    const newAvailable = [...availableOrigens, ...selectedFromSelectedOrigens];
    const newSelected = selectedOrigens.filter(
      (origem) => !selectedFromSelectedOrigens.includes(origem)
    );

    setAvailableOrigens(newAvailable);
    setSelectedOrigens(newSelected);
    setSelectedFromSelectedOrigens([]);
  };

  const moveAllToSelectedOrigens = () => {
    const newSelected = [...selectedOrigens, ...availableOrigens];
    setSelectedOrigens(newSelected);
    setAvailableOrigens([]);
  };

  const moveAllToAvailableOrigens = () => {
    const newAvailable = [...availableOrigens, ...selectedOrigens];
    setAvailableOrigens(newAvailable);
    setSelectedOrigens([]);
  };

  //EMPREGADOR

  const moveToSelectedEmpregadores = () => {
    const newSelected = [...selectedEmpregadores, ...selectedToMoveEmpregadores];
    const newAvailable = availableEmpregadores.filter(
      (empregador) => !selectedToMoveEmpregadores.includes(empregador)
    );

    setAvailableEmpregadores(newAvailable);
    setSelectedEmpregadores(newSelected);
    setSelectedToMoveEmpregadores([]);
  };

  const moveToAvailableEmpregadores = () => {
    const newAvailable = [...availableEmpregadores, ...selectedFromSelectedEmpregadores];
    const newSelected = selectedEmpregadores.filter(
      (empregador) => !selectedFromSelectedEmpregadores.includes(empregador)
    );

    setAvailableEmpregadores(newAvailable);
    setSelectedEmpregadores(newSelected);
    setSelectedFromSelectedEmpregadores([]);
  };

  const moveAllToSelectedEmpregadores = () => {
    const newSelected = [...selectedEmpregadores, ...availableEmpregadores];
    setSelectedEmpregadores(newSelected);
    setAvailableEmpregadores([]);
  };

  const moveAllToAvailableEmpregadores = () => {
    const newAvailable = [...availableEmpregadores, ...selectedEmpregadores];
    setAvailableEmpregadores(newAvailable);
    setSelectedEmpregadores([]);
  };

  // --- FUNÇÕES DE MOVIMENTAÇÃO (ORIGINADOR) ---
  const moveToSelectedOriginadores = () => {
    const newSelected = [...selectedOriginadores, ...selectedToMoveOriginadores];
    const newAvailable = availableOriginadores.filter((o) => !selectedToMoveOriginadores.includes(o));
    setAvailableOriginadores(newAvailable);
    setSelectedOriginadores(newSelected);
    setSelectedToMoveOriginadores([]);
  };

  const moveToAvailableOriginadores = () => {
    const newAvailable = [...availableOriginadores, ...selectedFromSelectedOriginadores];
    const newSelected = selectedOriginadores.filter((o) => !selectedFromSelectedOriginadores.includes(o));
    setAvailableOriginadores(newAvailable);
    setSelectedOriginadores(newSelected);
    setSelectedFromSelectedOriginadores([]);
  };

  const moveAllToSelectedOriginadores = () => {
    const newSelected = [...selectedOriginadores, ...availableOriginadores];
    setSelectedOriginadores(newSelected);
    setAvailableOriginadores([]);
  };

  const moveAllToAvailableOriginadores = () => {
    const newAvailable = [...availableOriginadores, ...selectedOriginadores];
    setAvailableOriginadores(newAvailable);
    setSelectedOriginadores([]);
  };
  // --------------------------------------------------------

  function capitalizeFirstLetter(str: string) {
    if (!str) return '';
    const formatted = str.replace(/_/g, ' '); 
    return formatted.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <>
      {alert && <CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />}
      
      {/* Modal de Agendamento */}
      {showAgendamentoModal && (
        <div className="modal fade show d-block" tabIndex={-1} role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Agendar Relatório</h5>
                <button type="button" className="close" aria-label="Fechar" onClick={() => setShowAgendamentoModal(false)}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>{errorRelatorio}</p>
                <p>Deseja agendar o relatório com os filtros preenchidos?</p>
                <div className="form-group">
                  <label htmlFor="dataAgendamento"><b>Data do Agendamento:</b></label>
                  <input
                    id="dataAgendamento"
                    type="date"
                    required
                    className="form-control"
                    value={agendamentoData}
                    onChange={(e) => setAgendamentoData(e.target.value)}
                    min={new Date().toISOString().split('T')[0]}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowAgendamentoModal(false)}>Cancelar</button>
                <button className="btn btn-primary" onClick={agendarRelatorio}>Agendar</button>
              </div>
            </div>
          </div> 
        </div>
      )} 

      <div className="position-relative m-md-3">
        {loading ? <Spinner loading={loading} /> : (
          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header">
              <strong>Relatório de Extrato Mensal</strong>
            </div>
            <div className="card-body">
              <div className="" style={{ marginTop: '10px' }}>
                <div className="row">
                  <div className="col-md-2" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                    <label>Período de Data <span style={{ color: 'red' }}>*</span></label>
                  </div>
                </div>
                <div className="row" style={{ marginTop: '5px' }}>
                  <div className="col-md-4">
                    <thead>
                      <tr>
                        <th style={{ width: "150px" }}><InputMask required mask="99/99/9999" className="form-control" type="text" value={dtBase1} onChange={(e) => setDtBase1((e.target.value).replace(/_/g, ""))} /></th>
                        <th style={{ width: "15px" }}> a </th>
                        <th style={{ width: "150px" }}><InputMask required mask="99/99/9999" className="form-control" type="text" value={dtBase2} onChange={(e) => setDtBase2((e.target.value).replace(/_/g, ""))} /></th>
                      </tr>
                    </thead>
                  </div>
                </div>
                <div className="row" style={{ marginTop: '10px' }}>
                  <div className="col-md-3">
                    <label>Tipo da Origem</label>
                    <select 
                      className="form-select" 
                      value={selectedOrigem} 
                      onChange={(e) => {
                        const novoTipo = e.target.value;
                        setSelectedOrigem(novoTipo); 
                        listarOrigens(novoTipo); 

                        // SE MUDAR PARA ALGO QUE NÃO SEJA PROMOTORA, LIMPA A SELEÇÃO DE ORIGINADORES
                        if (novoTipo !== 'PROMOTORA') {
                          setSelectedOriginadores([]);
                          setAvailableOriginadores([]); 
                          listarOriginadores(); // Garante que a lista reseta
                        }
                      }}
                    >
                      {tiposOrigemOptions.map((tipo) => (
                        <option key={tipo} value={tipo}>
                          {capitalizeFirstLetter(tipo)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

              </div>

              {/* --- DUAL LIST BOX PARA ORIGINADOR (SÓ APARECE SE PROMOTORA) --- */}
              {selectedOrigem === 'PROMOTORA' && (
                  <div style={{ display: 'flex', marginTop: '10px' }}>
                    <div>
                      <h6>{Originador.DESCRITIVO_GERAL} Disponíveis</h6>
                      <select
                        multiple
                        value={selectedToMoveOriginadores.map((p) => p.id!.toString())}
                        onChange={(e) => {
                          const options = e.target.options;
                          const selected = [];
                          for (let i = 0; i < options.length; i++) {
                            if (options[i].selected) {
                              const item = availableOriginadores.find(p => p.id!.toString() === options[i].value);
                              if (item) selected.push(item);
                            }
                          }
                          setSelectedToMoveOriginadores(selected);
                        }}
                        style={{ width: '575px', height: '180px' }}
                      >
                        {availableOriginadores.map((orig) => (
                          <option key={orig.id} value={orig.id!.toString()}>
                            {orig.id} - {orig.nome!}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      <button onClick={moveToSelectedOriginadores} style={{ margin: '5px' }}>{'>'}</button>
                      <button onClick={moveAllToSelectedOriginadores} style={{ margin: '5px' }}>{'>>'}</button>
                      <button onClick={moveToAvailableOriginadores} style={{ margin: '5px' }}>{'<'}</button>
                      <button onClick={moveAllToAvailableOriginadores} style={{ margin: '5px' }}>{'<<'}</button>
                    </div>
                    <div>
                      <h6>{Originador.DESCRITIVO_GERAL} Selecionados</h6>
                      <select
                        multiple
                        value={selectedFromSelectedOriginadores.map((p) => p.id!.toString())}
                        onChange={(e) => {
                          const options = e.target.options;
                          const selected = [];
                          for (let i = 0; i < options.length; i++) {
                            if (options[i].selected) {
                              const item = selectedOriginadores.find(p => p.id!.toString() === options[i].value);
                              if (item) selected.push(item);
                            }
                          }
                          setSelectedFromSelectedOriginadores(selected);
                        }}
                        style={{ width: '575px', height: '180px' }}
                      >
                        {selectedOriginadores.map((orig) => (
                          <option key={orig.id} value={orig.id!.toString()}>
                            {orig.id} - {orig.nome!}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
              )}
              {/* ------------------------------------------------------------- */}

              {/* QUADROS ORIGENS */}
              <div style={{ display: 'flex', marginTop: '10px' }}>
                <div>
                  <h6>{capitalizeFirstLetter(selectedOrigem.toUpperCase() === 'PROMOTORA' ? 'Promotoras' : selectedOrigem.toUpperCase() === 'PONTOVENDA' || selectedOrigem.toUpperCase() === 'PONTO_VENDA' ? 'Pontos de Venda' : selectedOrigem.toUpperCase() + 'es')} Disponíveis</h6>
                  <select
                    multiple
                    value={selectedToMoveOrigens.map((p) => p.id!.toString())}
                    onChange={(e) => {
                      const options = e.target.options;
                      const selected = [];
                      for (let i = 0; i < options.length; i++) {
                        if (options[i].selected) {
                          const origem = availableOrigens.find(p => p.id!.toString() === options[i].value);
                          if (origem) {
                            selected.push(origem);
                          }
                        }
                      }
                      setSelectedToMoveOrigens(selected);
                    }}
                    style={{ width: '575px', height: '180px' }}
                  >
                    {availableOrigens.map((origem) => (
                      <option key={origem.id} value={origem.id!.toString()}>
                        {origem.id} - {origem.nome!}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <button onClick={moveToSelectedOrigens} style={{ margin: '5px' }}>{'>'}</button>
                  <button onClick={moveAllToSelectedOrigens} style={{ margin: '5px' }}>{'>>'}</button>
                  <button onClick={moveToAvailableOrigens} style={{ margin: '5px' }}>{'<'}</button>
                  <button onClick={moveAllToAvailableOrigens} style={{ margin: '5px' }}>{'<<'}</button>
                </div>
                <div>
                  <h6>{capitalizeFirstLetter(selectedOrigem.toUpperCase() === 'PROMOTORA' ? 'Promotoras' : selectedOrigem.toUpperCase() === 'PONTOVENDA' || selectedOrigem.toUpperCase() === 'PONTO_VENDA' ? 'Pontos de Venda' : selectedOrigem.toUpperCase() + 'es')} Selecionados</h6>
                  <select
                    multiple
                    value={selectedFromSelectedOrigens.map((p) => p.id!.toString())}
                    onChange={(e) => {
                      const options = e.target.options;
                      const selected = [];
                      for (let i = 0; i < options.length; i++) {
                        if (options[i].selected) {
                          const origem = selectedOrigens.find(p => p.id!.toString() === options[i].value);
                          if (origem) {
                            selected.push(origem);
                          }
                        }
                      }
                      setSelectedFromSelectedOrigens(selected);
                    }}
                    style={{ width: '575px', height: '180px' }}
                  >
                    {selectedOrigens.map((origem) => (
                      <option key={origem.id} value={origem.id!.toString()}>
                        {origem.id} - {origem.nome!}
                      </option>
                    ))}
                  </select>
                </div>
              </div>


              <div style={{ display: 'flex', marginTop: '10px' }}>
                <div>
                  <h6>Empregadores Disponíveis </h6>
                  < select
                    multiple
                    value={selectedToMoveEmpregadores.map((e) => e.id!.toString())}
                    onChange={(e) => {
                      const options = e.target.options;
                      const selected = [];
                      for (let i = 0; i < options.length; i++) {
                        if (options[i].selected) {
                          const empregador = availableEmpregadores.find(e => e.id!.toString() === options[i].value);
                          if (empregador) {
                            selected.push(empregador);
                          }
                        }
                      }
                      setSelectedToMoveEmpregadores(selected);
                    }}
                    style={{ width: '575px', height: '250px' }}
                  >
                    {
                      availableEmpregadores.map((empregador) => (
                        <option key={empregador.id} value={empregador.id!.toString()} >
                          {empregador.id} - {empregador.nome!}
                        </option>
                      ))
                    }
                  </select>
                </div>
                < div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <button onClick={moveToSelectedEmpregadores} style={{ margin: '5px' }}> {'>'} </button>
                  < button onClick={moveAllToSelectedEmpregadores} style={{ margin: '5px' }}> {'>>'} </button>
                  < button onClick={moveToAvailableEmpregadores} style={{ margin: '5px' }}> {'<'} </button>
                  < button onClick={moveAllToAvailableEmpregadores} style={{ margin: '5px' }}> {'<<'} </button>
                </div>
                < div >
                  <h6>Empregadores Selecionados </h6>
                  < select
                    multiple
                    value={selectedFromSelectedEmpregadores.map((e) => e.id!.toString())}
                    onChange={(e) => {
                      const options = e.target.options;
                      const selected = [];
                      for (let i = 0; i < options.length; i++) {
                        if (options[i].selected) {
                          const empregador = selectedEmpregadores.find(e => e.id!.toString() === options[i].value);
                          if (empregador) {
                            selected.push(empregador);
                          }
                        }
                      }
                      setSelectedFromSelectedEmpregadores(selected);
                    }}
                    style={{ width: '575px', height: '250px' }}
                  >
                    {
                      selectedEmpregadores.map((empregador) => (
                        <option key={empregador.id} value={empregador.id!.toString()} >
                          {empregador.id} - {empregador.nome!}
                        </option>
                      ))
                    }
                  </select>
                </div>
              </div>

              <div className="row" style={{ marginTop: '20px', height: '50px', maxWidth: '70%' }}>
                <div className="col-md-3">
                  <button className="input-group-btn" id="App-button-cor-principal"
                    style={{
                      width: '80%', display: 'flex', alignItems: 'center',
                      justifyContent: 'center', border: '1px solid LightGrey', borderRadius: '5px', height: '100%', minWidth: '50px'
                    }} onClick={gerarRelatorio}>
                    <a>
                      <FontAwesomeIcon icon={faPrint} style={{ color: 'White', fontSize: 'larger', marginTop: '5px' }} />
                    </a>
                    <strong style={{ color: 'White', marginLeft: '5px', fontSize: 'larger' }}> Gerar Relatório</strong>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div >
    </>
  );
}
export default ExtratoMensalComponent;